import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, ShieldCheck, Menu, X, LogOut, ChevronLeft,
  Wallet, Banknote,
} from "lucide-react";

const AdminSidebar = ({ isCollapsed, setIsCollapsed, isMobileOpen, setIsMobileOpen }) => {
  const { pathname } = useLocation();
  const navigate     = useNavigate();

  const isActive = (path, exact = false) =>
    exact ? pathname === path : pathname.startsWith(path);

  const adminLinks = [
    { name: "Dashboard",      icon: <LayoutDashboard size={18} />, path: "/admin-dashboard",              exact: true },
    { name: "Budget & Cycles",icon: <Wallet size={18} />,          path: "/admin-dashboard/budget" },
    { name: "Disbursements",  icon: <Banknote size={18} />,        path: "/admin-dashboard/disbursements" },
    { name: "Audit Logs",     icon: <ShieldCheck size={18} />,     path: "/admin-dashboard/audit" },
  ];

  return (
    <aside
      className={`
        fixed md:static top-16 left-0 z-40
        h-[calc(100vh-4rem)]
        bg-gray-900 text-gray-100
        border-r border-gray-800
        transition-all duration-300 ease-in-out
        ${isCollapsed ? "w-16" : "w-64"}
        ${isMobileOpen ? "block" : "hidden md:block"}
        flex flex-col
      `}
    >
      {/* Header */}
      <div className={`flex items-center p-4 border-b border-gray-800 ${isCollapsed ? "justify-center" : "justify-between"}`}>
        {!isCollapsed && (
          <span className="font-semibold text-white text-sm truncate">CDF Admin Panel</span>
        )}
        <button
          onClick={() =>
            window.innerWidth < 768
              ? setIsMobileOpen(false)
              : setIsCollapsed(!isCollapsed)
          }
          className="p-1.5 rounded-lg hover:bg-gray-800 text-gray-400 hover:text-white transition-colors flex-shrink-0"
          aria-label="Toggle sidebar"
        >
          {window.innerWidth < 768
            ? <X size={17} />
            : isCollapsed
            ? <Menu size={17} />
            : <ChevronLeft size={17} />
          }
        </button>
      </div>

      {/* Nav links */}
      <nav className="p-3 space-y-1 flex-1">
        {adminLinks.map((link) => (
          <Link
            key={link.name}
            to={link.path}
            onClick={() => setIsMobileOpen?.(false)}
            title={isCollapsed ? link.name : undefined}
            className={`flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-medium transition-colors duration-150 ${
              isActive(link.path, link.exact)
                ? "bg-primary text-white shadow-sm"
                : "text-gray-400 hover:bg-gray-800 hover:text-white"
            }`}
          >
            <span className="flex-shrink-0">{link.icon}</span>
            {!isCollapsed && <span className="truncate">{link.name}</span>}
          </Link>
        ))}
      </nav>

      {/* Logout */}
      <button
        onClick={() => {
          localStorage.removeItem("user");
          navigate("/admin-login");
        }}
        title={isCollapsed ? "Logout" : undefined}
        className="mx-3 mb-4 flex items-center gap-3 px-3 py-2.5 rounded-xl bg-red-600 text-white hover:bg-red-700 active:scale-95 transition-all duration-150 text-sm font-medium"
      >
        <LogOut size={17} className="flex-shrink-0" />
        {!isCollapsed && "Logout"}
      </button>
    </aside>
  );
};

export default AdminSidebar;
